import { render } from "./VersionChecker.vue?vue&type=template&id=92abe126&scoped=true"
import script from "./VersionChecker.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionChecker.vue?vue&type=script&setup=true&lang=js"

import "./VersionChecker.vue?vue&type=style&index=0&id=92abe126&scoped=true&lang=css"

import exportComponent from "/Volumes/ext/winglet/license/grm/webpack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92abe126"],['__file',"src/components/VersionChecker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "92abe126"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('92abe126', __exports__)) {
    api.reload('92abe126', __exports__)
  }
  
  module.hot.accept("./VersionChecker.vue?vue&type=template&id=92abe126&scoped=true", () => {
    api.rerender('92abe126', render)
  })

}


export default __exports__